import React, { useEffect, useState } from 'react'
import { Card, Col, Label, Row } from 'reactstrap'
import { SimpleSubTitleCard, SimpleTitleCard } from 'styles/global'
import {
  ButtonConfigKanban,
  CardColunaEtapas,
  CardColunaPipeline,
  EtapaIcon,
  Info,
  SubTitulo,
  Titulo
} from '../../style'
import { FiSave, FiTrash } from 'react-icons/fi'
import { IoIosArrowDown, IoIosArrowUp } from 'react-icons/io'
import InputCustom from 'components/Inputs'
import { Switch } from 'components/Switch'
import { AiOutlineClose, AiOutlinePlusCircle } from 'react-icons/ai'
import {
  CONFIGURACAO_KANBAN,
  InvalidsRegisterEtapas,
  RegisterEtapas
} from 'store/modules/backoffice/configuracaoKanban/types'
import { ApplicationState } from 'store'
import { useSelector } from 'react-redux'
import * as configuracaoKanbanActions from 'store/modules/backoffice/configuracaoKanban/actions'
import useRedux from 'hooks/useRedux'
import { HiOutlinePencil } from 'react-icons/hi'
import { schemaEtapas } from '../../constants/schemas'
import * as yup from 'yup'
import { IconButton, Tooltip } from '@mui/material'
import { toast } from 'react-toastify'
import CustomSelect from 'components/Select'
import ModalExclusao from 'components/ModalExclusao'
import PrivateComponent from 'components/PrivateComponent'

const Etapas = () => {
  const { tabEtapas, activeTab } = useSelector<
    ApplicationState,
    CONFIGURACAO_KANBAN
  >((state) => state.configuracaoKanban)

  const { dispatch } = useRedux()

  const [selectedId, setSelectedId] = useState('')

  interface RegisterFields extends Omit<RegisterEtapas, 'etapasPermitidas'> {
    etapaPermitida: string
  }

  function onChange<T extends keyof RegisterFields>(
    value: RegisterFields[T],
    field: T
  ) {
    if (field === 'etapaPermitida') {
      dispatch(
        configuracaoKanbanActions.setRegisterEtapasPermitidasTabEtapas(
          value as string
        )
      )
    } else {
      dispatch(
        configuracaoKanbanActions.setRegisterFieldsTabEtapas(value, field)
      )
    }
  }

  function onSave() {
    dispatch(configuracaoKanbanActions.cleanInvalidsRegisterTabEtapas())
    schemaEtapas
      .validate(
        {
          ...tabEtapas.register,
          pipelineId:
            tabEtapas.register?.pipelineId || tabEtapas.pipelineSelecionado
        },
        { abortEarly: false }
      )
      .then(() => {
        if (tabEtapas.register?.id) {
          dispatch(configuracaoKanbanActions.editarEtapaTabEtapasSaga())
        } else {
          dispatch(configuracaoKanbanActions.salvarEtapaTabEtapasSaga())
        }
      })
      .catch((err: yup.ValidationError) => {
        console.log(err.inner)
        err.inner.forEach((e: yup.ValidationError) => {
          dispatch(
            configuracaoKanbanActions.setInvalidsFieldsRegisterTabEtapas(
              {
                invalid: true,
                message: e.message
              },
              e.path as keyof InvalidsRegisterEtapas
            )
          )
        })
        toast.warning('Por favor, verifique os campos inválidos.')
      })
  }

  useEffect(() => {
    if (activeTab === 1) {
      dispatch(configuracaoKanbanActions.getPipelinesTabEtapasSaga())
    }
  }, [activeTab, dispatch])

  useEffect(() => {
    if (
      activeTab === 1 &&
      (tabEtapas.register?.pipelineId || tabEtapas.pipelineSelecionado)
    ) {
      const pipelineId =
        tabEtapas.register?.pipelineId || tabEtapas.pipelineSelecionado || ''
      dispatch(
        configuracaoKanbanActions.getEtapasPipelineTabEtapasSaga(pipelineId)
      )
      dispatch(
        configuracaoKanbanActions.getEtapasPermitidasTabEtapasSaga(pipelineId)
      )
    }
  }, [
    activeTab,
    dispatch,
    tabEtapas.pipelineSelecionado,
    tabEtapas.register?.pipelineId
  ])

  return (
    <div className="d-flex flex-column">
      <div className="d-flex justify-content-between align-items-start">
        <div>
          <SimpleTitleCard className="pb-0">Editor de Etapas</SimpleTitleCard>
          <SimpleSubTitleCard>
            Configure etapas, SLAs e fluxo de trabalho
          </SimpleSubTitleCard>
        </div>
        <div>
          <PrivateComponent screen="configuracaoKanban" typeActions="gravar">
            <ButtonConfigKanban
              onClick={() => {
                dispatch(
                  configuracaoKanbanActions.cleanInvalidsRegisterTabEtapas()
                )
                dispatch(
                  configuracaoKanbanActions.setRegisterTabEtapas({
                    id: '',
                    nome: '',
                    descricao: '',
                    cor: '#4022c5',
                    etapasPermitidas: [],
                    pipelineId: '',
                    status: true
                  })
                )
                dispatch(
                  configuracaoKanbanActions.setEtapaPipelineSelecionadoTabEtapas(
                    null
                  )
                )
              }}
              className="btn-blue"
            >
              <AiOutlinePlusCircle />
              <span>Nova Etapa</span>
            </ButtonConfigKanban>
          </PrivateComponent>
        </div>
      </div>
      <Row className="d-flex row-gap-20">
        <Col md={4}>
          <Card className="p-4">
            <div className="d-flex flex-column gap-2">
              <Titulo>Selecionar Pipeline</Titulo>
              {tabEtapas.pipelines.map((pipeline) => (
                <CardColunaPipeline
                  isActive={tabEtapas.pipelineSelecionado === pipeline.id}
                  key={pipeline.id}
                  onClick={() => {
                    dispatch(
                      configuracaoKanbanActions.cleanInvalidsRegisterTabEtapas()
                    )
                    dispatch(
                      configuracaoKanbanActions.setRegisterTabEtapas(null)
                    )
                    dispatch(
                      configuracaoKanbanActions.setPipelineSelecionadoTabEtapas(
                        pipeline.id
                      )
                    )
                  }}
                >
                  <Label>{pipeline.nome}</Label>
                  <span>{pipeline.etapas?.length || 0} etapas</span>
                </CardColunaPipeline>
              ))}
            </div>
          </Card>
        </Col>
        <Col md={4}>
          <Card className="p-4">
            <div className="d-flex flex-column gap-2">
              <Titulo>Etapas do Pipeline</Titulo>
              {tabEtapas.etapasPipeline.map((etapa) => (
                <CardColunaEtapas
                  isActive={tabEtapas.etapaPipelineSelecionado === etapa.id}
                  key={etapa.id}
                  onClick={(
                    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
                  ) => {
                    e.stopPropagation()
                    dispatch(
                      configuracaoKanbanActions.setEtapaPipelineSelecionadoTabEtapas(
                        etapa.id
                      )
                    )
                    dispatch(
                      configuracaoKanbanActions.getEtapaByIdTabEtapasSaga(
                        etapa.id
                      )
                    )
                  }}
                >
                  <div className="d-flex align-items-center gap-2">
                    <EtapaIcon etapaColor={etapa.cor} />
                    <div className="d-flex flex-column">
                      <Label>{etapa.nome}</Label>
                    </div>
                  </div>
                  <div className="d-flex align-items-center gap-4">
                    <PrivateComponent
                      screen="configuracaoKanban"
                      typeActions="gravar"
                    >
                      <div className="d-flex gap-2">
                        {etapa.ordem > 1 && (
                          <IconButton
                            size="small"
                            onClick={(e) => {
                              e.stopPropagation()
                              dispatch(
                                configuracaoKanbanActions.alterarOrdemEtapaTabEtapasSaga(
                                  {
                                    id: etapa.id,
                                    ordem: etapa.ordem - 1
                                  }
                                )
                              )
                            }}
                          >
                            <IoIosArrowUp />
                          </IconButton>
                        )}
                        {tabEtapas.etapasPipeline.length > etapa.ordem && (
                          <IconButton
                            size="small"
                            onClick={(e) => {
                              e.stopPropagation()
                              dispatch(
                                configuracaoKanbanActions.alterarOrdemEtapaTabEtapasSaga(
                                  {
                                    id: etapa.id,
                                    ordem: etapa.ordem + 1
                                  }
                                )
                              )
                            }}
                          >
                            <IoIosArrowDown />
                          </IconButton>
                        )}
                      </div>
                    </PrivateComponent>
                    <PrivateComponent
                      screen="configuracaoKanban"
                      typeActions="deletar"
                    >
                      <div>
                        <IconButton
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation()
                            setSelectedId(etapa.id)
                          }}
                        >
                          <FiTrash />
                        </IconButton>
                      </div>
                    </PrivateComponent>
                  </div>
                </CardColunaEtapas>
              ))}
            </div>
          </Card>
        </Col>
        <Col md={4}>
          <Card className="p-4">
            {tabEtapas.register ? (
              <div className="d-flex flex-column gap-2">
                <div className="d-flex justify-content-between align-items-center">
                  <Titulo>
                    {tabEtapas.register.id ? 'Editar' : 'Nova'} Etapa
                  </Titulo>
                  <div className="d-flex gap-2">
                    <PrivateComponent
                      screen="configuracaoKanban"
                      typeActions="gravar"
                    >
                      <ButtonConfigKanban
                        onClick={onSave}
                        className="btn-blue"
                        disabled={tabEtapas.visualizacao}
                      >
                        <FiSave />
                        <span>Salvar</span>
                      </ButtonConfigKanban>
                    </PrivateComponent>
                    <ButtonConfigKanban
                      onClick={() => {
                        dispatch(
                          configuracaoKanbanActions.cleanRegisterTabEtapas()
                        )
                        dispatch(
                          configuracaoKanbanActions.setEtapaPipelineSelecionadoTabEtapas(
                            null
                          )
                        )
                      }}
                      className="btn-light"
                    >
                      <AiOutlineClose />
                    </ButtonConfigKanban>
                  </div>
                </div>
                <Row className="d-flex row-gap-15">
                  <Col md={12}>
                    <Label className="label-12">Nome da Etapa</Label>
                    <InputCustom
                      type="text"
                      placeholder="Nome da Etapa"
                      value={tabEtapas.register.nome}
                      onChange={(e) => {
                        onChange(e.target.value, 'nome')
                      }}
                      invalid={tabEtapas.invalids.nome?.invalid}
                      message={tabEtapas.invalids.nome?.message}
                      disabled={tabEtapas.visualizacao}
                    />
                  </Col>
                  <Col md={12}>
                    <Label className="label-12">Descrição</Label>
                    <InputCustom
                      type="text"
                      placeholder="Descrição"
                      value={tabEtapas.register.descricao}
                      onChange={(e) => {
                        onChange(e.target.value, 'descricao')
                      }}
                      invalid={tabEtapas.invalids.descricao?.invalid}
                      message={tabEtapas.invalids.descricao?.message}
                      disabled={tabEtapas.visualizacao}
                    />
                  </Col>
                  {!tabEtapas.pipelineSelecionado && (
                    <Col md={12}>
                      <Label className="label-12">Pipeline</Label>
                      <CustomSelect
                        options={tabEtapas.pipelines}
                        value={tabEtapas.register.pipelineId}
                        onChange={(e) => {
                          onChange(e, 'pipelineId')
                        }}
                        accessorLabel="descricao"
                        accessorValue="id"
                        invalid={tabEtapas.invalids.pipelineId?.invalid}
                        message={tabEtapas.invalids.pipelineId?.message}
                        disabled={tabEtapas.visualizacao}
                      />
                    </Col>
                  )}
                  <Col md={2}>
                    <Label className="label-12">Cor</Label>
                    <InputCustom
                      type="color"
                      value={tabEtapas.register.cor}
                      onChange={(e) => {
                        onChange(e.target.value, 'cor')
                      }}
                      invalid={tabEtapas.invalids.cor?.invalid}
                      disabled={tabEtapas.visualizacao}
                    />
                  </Col>
                  <Col md={10}>
                    <Label className="label-12">&nbsp;</Label>
                    <InputCustom
                      placeholder="#ffffff"
                      value={tabEtapas.register.cor}
                      invalid={tabEtapas.invalids.cor?.invalid}
                      message={tabEtapas.invalids.cor?.message}
                      disabled
                    />
                  </Col>
                  <Col className="d-flex align-items-center gap-3" md={4}>
                    <Switch
                      checked={tabEtapas.register.status}
                      onChange={(e) => {
                        onChange(e.target.checked, 'status')
                      }}
                      invalid={tabEtapas.invalids.status?.invalid}
                    />
                    <Label className="label-12 mb-0">Etapa ativa</Label>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div className="d-flex flex-column gap-2">
                      <SubTitulo>Próximas Etapas Permitidas</SubTitulo>
                      <Info>
                        Define para quais etapas um lead pode ser movido a
                        partir desta etapa
                      </Info>
                      {tabEtapas.invalids.etapasPermitidas?.invalid && (
                        <Tooltip
                          title={tabEtapas.invalids.etapasPermitidas?.message}
                          placement="bottom-start"
                        >
                          <span className="error-message">
                            {tabEtapas.invalids.etapasPermitidas?.message}
                          </span>
                        </Tooltip>
                      )}
                    </div>
                    {tabEtapas.etapasPermitidas.map((etapaPermitida) => {
                      return (
                        <div
                          key={etapaPermitida.id}
                          className="d-flex align-items-center gap-2"
                        >
                          <Switch
                            checked={tabEtapas.register?.etapasPermitidas?.includes(
                              etapaPermitida.id
                            )}
                            onChange={() => {
                              onChange(etapaPermitida.id, 'etapaPermitida')
                            }}
                            disabled={tabEtapas.visualizacao}
                          />
                          <EtapaIcon etapaColor={etapaPermitida.cor} />
                          <span>{etapaPermitida.nome}</span>
                        </div>
                      )
                    })}
                  </Col>
                </Row>
              </div>
            ) : (
              <div className="d-flex flex-column gap-2">
                <Titulo>Selecione uma Etapa</Titulo>
                <div className="d-flex flex-column align-items-center justify-content-center gap-5 py-5">
                  <HiOutlinePencil size={40} />
                  <Info>Selecione uma etapa para editar suas propriedades</Info>
                </div>
              </div>
            )}
          </Card>
        </Col>
      </Row>
      <ModalExclusao
        isOpen={!!selectedId}
        toggle={() => {
          setSelectedId('')
        }}
        onRemove={() => {
          dispatch(
            configuracaoKanbanActions.removerEtapaTabEtapasSaga(selectedId)
          )
          setSelectedId('')
        }}
        customMessage="Deseja realmente excluir esta etapa?"
      />
    </div>
  )
}

export default Etapas
